import { useEffect, type PropsWithChildren, type ReactNode } from "react";

import clsx from "clsx";
import { tinykeys } from "tinykeys";

import { NavLinkContent } from "./nav-link-content";
import { Tooltip } from "./tooltip";

interface Props {
  to: string;
  isExpanded: boolean;
  icon: ReactNode;
  shortcut?: string;
}

export const NavOutsideLink = ({
  to,
  isExpanded,
  icon,
  shortcut,
  children,
}: PropsWithChildren<Props>) => {
  useEffect(() => {
    const unsubscribe = tinykeys(window, {
      [`$mod+${shortcut}`]: (event) => {
        event.preventDefault();
        window.open(to, "_blank", "noopener noreferrer");
      },
    });

    return () => {
      unsubscribe();
    };
  });

  return (
    <Tooltip content={isExpanded ? null : children} shortcut={shortcut}>
      <a
        className={clsx("block cursor-pointer no-underline", {
          "m-1.5": !isExpanded,
        })}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
      >
        <NavLinkContent
          isActive={false}
          icon={icon}
          isExpanded={isExpanded}
          shortcut={shortcut}
        >
          {children}
        </NavLinkContent>
      </a>
    </Tooltip>
  );
};
